import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/router-compatibility';
import { setLocation as selectLocation, setHousingUnit as selectHousingUnit } from '../../core/store/.';
import useUnleashHook from '../../core/unleash/useUnleashHook';
import { UnleashService } from '../../services';
import UserManagement from './user-management';
import { USER_MANAGEMENT_PATH } from '../split-location-context';

const UserManagementRoute = (props) => {
  const { isFlagEnabled } = useUnleashHook(UnleashService.FLAGS.SPLIT_LOCATION_USER_MANAGEMENT);
  if (!isFlagEnabled()) {
    const { pathname, search = '' } = props.location;
    return <Navigate to={`/manage${pathname.slice(USER_MANAGEMENT_PATH.length)}${search}`} replace />;
  }
  return <UserManagement {...props} />;
};

const mapStateToProps = (state) => state.app;

const mapDispatchToProps = (dispatch) => ({
  selectLocation: (location) => dispatch(selectLocation(location)),
  selectHousingUnit: (housingUnit) => dispatch(selectHousingUnit(housingUnit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserManagementRoute));
